import React from 'react';
import { useReveal } from '../lib/useReveal';
const PAIN_POINTS = ['Cursos vacíos o caros', 'Información que confunde', 'No saber cómo practicar'];
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 relative overflow-hidden border-t border-white/5" data-id="element-320">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-321">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-322">
          <div className="text-center mb-8" data-id="element-323">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight text-white" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-324">
              Si estás acá, no es casualidad. El Reiki te está llamando.
            </h2>
            <div className="text-lg md:text-xl text-gray-300 space-y-4 font-medium" data-id="element-325">
              <p className="text-[#f0c040] font-bold" data-id="element-326">
                El problema no es aprenderlo… es encontrar una formación clara y
                real.
              </p>
            </div>
          </div>

          <div className="max-w-2xl mx-auto" data-id="element-327">
            <h3 className="text-xl md:text-2xl font-serif font-bold text-[#f0c040] mb-8 text-center" data-id="element-328">
              ¿Te pasó?
            </h3>

            <ul className="space-y-6 flex flex-col items-center" data-id="element-329">
              {PAIN_POINTS.map((point, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-330">
                  <span className="text-[#eab308] text-xl leading-none flex-shrink-0" data-id="element-331">
                    ✦
                  </span>
                  <span className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-332">
                    {point}
                  </span>
                </li>)}
            </ul>

            <div className="mt-14 text-center" data-id="element-333">
              <p className="text-[#f0c040] font-serif italic text-xl md:text-2xl font-bold" data-id="element-334">
                💫 Acá empieza tu camino de verdad.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}